<fieldset class="grid" aria-label="Einstellungen zur Eintragungsmitteilung" data-test-id="aufgabe-mitteilung-root">
	<fieldset class="mitteilung" aria-label="Gruppen von Adressaten">
		<!-- EIGENTUEMER_NEU -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anEigentuemerNeuSenden"
				(change)="toggleEigentuemerNeuMitteilungGroup($event.checked)"
				data-test-id="eigentuemer-neu-checkbox">
				Eigentümer neu
			</mat-checkbox>
		</div>
		@if (bodyControls.eigentuemerNeuMitteilung.enabled) {
			<fieldset class="row" aria-label="Optionen wählen">
				<div class="column-sub" data-test-id="eigentuemer-neu-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="eigentuemerNeuControls.blattabschrift"
						data-test-id="eigentuemer-neu-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="eigentuemerNeuControls.zertifikatsBerichtigung"
						data-test-id="eigentuemer-neu-zertifikatsberichtigung-checkbox">
						{{ isBSR() ? mitteilungen.SCHIFFSBRIEF : mitteilungen.SCHIFFSZERTIFIKAT }}
					</mat-checkbox>
					@if (!isBSR()) {
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="eigentuemerNeuControls.auszugsEinreichung"
							data-test-id="eigentuemer-neu-auszugseinreichung-checkbox">
							{{ mitteilungen.ZERTIFIKATSAUSZUG }}
						</mat-checkbox>
					}
				</div>
			</fieldset>
		}

		<!-- EIGENTUEMER_ALT -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anEigentuemerAltSenden"
				(change)="toggleEigentuemerAltMitteilungGroup($event.checked)"
				data-test-id="eigentuemer-alt-checkbox">
				Eigentümer alt
			</mat-checkbox>
		</div>
		@if (bodyControls.eigentuemerAltMitteilung.enabled) {
			<fieldset class="row" aria-label="Optionen wählen">
				<div class="column-sub" data-test-id="eigentuemer-alt-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="eigentuemerAltControls.blattabschrift"
						data-test-id="eigentuemer-alt-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="eigentuemerAltControls.zertifikatsBerichtigung"
						data-test-id="eigentuemer-alt-zertifikatsberichtigung-checkbox">
						{{ isBSR() ? mitteilungen.SCHIFFSBRIEF : mitteilungen.SCHIFFSZERTIFIKAT }}
					</mat-checkbox>
					@if (!isBSR()) {
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="eigentuemerAltControls.auszugsEinreichung"
							data-test-id="eigentuemer-alt-auszugseinreichung-checkbox">
							{{ mitteilungen.ZERTIFIKATSAUSZUG }}
						</mat-checkbox>
					}
				</div>
			</fieldset>
		}

		<!-- EINGETRAGENER_EIGENTUEMER -->
		@if (!excludeEingetragenerEigentuemer()) {
			<div class="row">
				<mat-checkbox
					class="column focus-inwards-dark"
					color="primary"
					[formControl]="bodyControls.anEingetragenerEigentuemerSenden"
					(change)="toggleEingetragenerEigentuemerMitteilungGroup($event.checked)"
					data-test-id="eingetragener-eigentuemer-checkbox">
					Eingetragener Eigentümer
				</mat-checkbox>
			</div>
			@if (bodyControls.eingetragenerEigentuemerMitteilung.enabled) {
				<fieldset class="row" aria-label="Optionen wählen">
					<div class="column-sub" data-test-id="eingetragener-eigentuemer-mitteilung">
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="eingetragenerEigentuemerControls.blattabschrift"
							data-test-id="eingetragener-eigentuemer-blattabschrift-checkbox">
							{{ mitteilungen.BLATTABSCHRIFT }}
						</mat-checkbox>
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="eingetragenerEigentuemerControls.zertifikatsBerichtigung"
							data-test-id="eingetragener-eigentuemer-zertifikatsberichtigung-checkbox">
							{{ mitteilungen.SCHIFFSZERTIFIKAT }}
						</mat-checkbox>
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="eingetragenerEigentuemerControls.auszugsEinreichung"
							data-test-id="eingetragener-eigentuemer-auszugseinreichung-checkbox">
							{{ mitteilungen.ZERTIFIKATSAUSZUG }}
						</mat-checkbox>
					</div>
				</fieldset>
			}
		}

		<!-- GLAEUBIGER_NEU -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anGlaeubigerNeuSenden"
				(change)="toggleGlaeubigerNeuMitteilungGroup($event.checked)"
				data-test-id="glaeubiger-neu-checkbox">
				Gläubiger neu
			</mat-checkbox>
		</div>
		@if (bodyControls.glaeubigerNeuMitteilung.enabled) {
			<fieldset class="row">
				<legend aria-label="Optionen wählen"></legend>
				<div class="column-sub" data-test-id="glaeubiger-neu-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="glaeubigerNeuControls.blattabschrift"
						data-test-id="glaeubiger-neu-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="glaeubigerNeuControls.zertifikatsBerichtigung"
						data-test-id="glaeubiger-neu-zertifikatsberichtigung-checkbox">
						{{ isBSR() ? mitteilungen.SCHIFFSBRIEF : mitteilungen.SCHIFFSZERTIFIKAT }}
					</mat-checkbox>
				</div>
			</fieldset>
		}

		<!-- GLAEUBIGER_ALT -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anGlaeubigerAltSenden"
				(change)="toggleGlaeubigerAltMitteilungGroup($event.checked)"
				data-test-id="glaeubiger-alt-checkbox">
				Gläubiger alt
			</mat-checkbox>
		</div>
		@if (bodyControls.glaeubigerAltMitteilung.enabled) {
			<fieldset class="row" aria-label="Optionen wählen">
				<div class="column-sub" data-test-id="glaeubiger-alt-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="glaeubigerAltControls.blattabschrift"
						data-test-id="glaeubiger-alt-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="glaeubigerAltControls.zertifikatsBerichtigung"
						data-test-id="glaeubiger-alt-zertifikatsberichtigung-checkbox">
						{{ isBSR() ? mitteilungen.SCHIFFSBRIEF : mitteilungen.SCHIFFSZERTIFIKAT }}
					</mat-checkbox>
				</div>
			</fieldset>
		}

		<!-- Notar -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anNotarSenden"
				(change)="toggleNotarMitteilungGroup($event.checked)"
				data-test-id="notar-checkbox">
				Notar
			</mat-checkbox>
		</div>
		@if (bodyControls.notarMitteilung.enabled) {
			<fieldset class="row">
				<legend aria-label="Optionen wählen"></legend>
				<div class="column-sub" data-test-id="notar-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="notarControls.blattabschrift"
						data-test-id="notar-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
				</div>
			</fieldset>
		}

		<!-- Behörden -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anBehoerdenSenden"
				data-test-id="behoerden-checkbox">
				Behörden
			</mat-checkbox>
		</div>

		<!-- BSH -->
		@if (!isBSR()) {
			<div class="row">
				<mat-checkbox
					class="column focus-inwards-dark"
					color="primary"
					[formControl]="bodyControls.anBshSenden"
					(change)="toggleBshMitteilungGroup($event.checked)"
					data-test-id="bsh-checkbox">
					{{ mitteilungen.BSH }}
				</mat-checkbox>
			</div>
			@if (bodyControls.bshMitteilung.enabled) {
				<fieldset class="row" aria-label="Optionen wählen">
					<div class="column-sub" data-test-id="bsh-mitteilung">
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="bshControls.blattabschrift"
							data-test-id="bsh-blattabschrift-checkbox">
							{{ mitteilungen.BEGLAUBIGTE_BLATTABSCHRIFT }}
						</mat-checkbox>
					</div>
				</fieldset>
			}
		}
		<!-- Rechtsanwaelte -->
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.anRechtsanwaelteSenden"
				(change)="toggleRechtsanwaltMitteilungGroup($event.checked)"
				data-test-id="rechtsanwaelte-checkbox">
				Rechtsanwalt
			</mat-checkbox>
		</div>
		@if (bodyControls.rechtsanwaelteMitteilung.enabled) {
			<fieldset class="row">
				<legend aria-label="Optionen wählen"></legend>
				<div class="column-sub" data-test-id="rechtsanwaelte-mitteilung">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="rechtsanwaelteControls.blattabschrift"
						data-test-id="rechtsanwaelte-blattabschrift-checkbox">
						{{ mitteilungen.BLATTABSCHRIFT }}
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="rechtsanwaelteControls.zertifikatsBerichtigung"
						data-test-id="rechtsanwaelte-zertifikatsberichtigung-checkbox">
						{{ isBSR() ? mitteilungen.SCHIFFSBRIEF : mitteilungen.SCHIFFSZERTIFIKAT }}
					</mat-checkbox>
				</div>
			</fieldset>
		}
	</fieldset>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.EINTRAGUNGSMITTEILUNG" />
</fieldset>
